export const TIME_PER_MONTH = 1000 * 60 * 60 * 24 * 30;
export const TIME_PER_DAY = 1000 * 60 * 60 * 24;
export const TIME_PER_HOUR = 1000 * 60 * 60;
export const TIME_PER_MINUTE = 1000 * 60;
